import { Component, Input } from '@angular/core';

import {
  CandidatesConfig,
  CandidatesPrivileges,
} from '@modules/candidates/candidates.abstract.config';
import { AssociationModule, AssociationType } from '@shared';

@Component({
  selector: 'mojo-candidate-resume-card-header',
  templateUrl: './candidate-resume-card-header.component.html',
  styleUrls: ['./candidate-resume-card-header.component.scss'],
})
export class CandidateResumeCardHeaderComponent {
  types = AssociationType;
  modules = AssociationModule;
  privileges: CandidatesPrivileges;
  @Input() showTitle = true;
  constructor(private candidatesConfig: CandidatesConfig) {
    this.privileges = this.candidatesConfig.privileges;
  }
}
